/**
 * Index a flat list of validation errors by field path and by section name.
 *
 * @param {Array<{ field?: string, section?: string, code?: string, message?: string, severity?: string }>} errors
 * @returns {{ byField: Map<string, object>, bySection: Map<string, object[]> }}
 */
export function indexValidationErrors(errors = []) {
  const byField = new Map();
  const bySection = new Map();
  for (const err of errors) {
    if (err.field) byField.set(err.field, err);
    const section = err.section || '_';
    const list = bySection.get(section) || [];
    list.push(err);
    bySection.set(section, list);
  }
  return { byField, bySection };
}
